import { Avatar, Col, Flex, List, Row, Space } from "antd";
import { RxCross2 } from "react-icons/rx";

/**
 * List of the Recipient who will get the email.
 *
 * @param {Object} props - component Props
 * @param {Array<{ObjectId: string, Name: string}>} [props.persons] - List of selected persons.
 * @param {(ObjectId: string) => void} [props.handleRemovePerson] - Function to reset/close the modal.
 * @returns {JSX.Element}
 */
function PersonRecipientsList({ persons, handleRemovePerson }) {
  return (
    <div className="recipient-list-container">
      <List
        bordered
        dataSource={persons || []}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              description={
                <>
                  <Row>
                    <Col span={24}>
                      <Flex justify="space-between" align="center">
                        <Space>
                          <Avatar
                            style={{
                              backgroundColor: "lightblue",
                              verticalAlign: "middle",
                              color: "blue"
                            }}
                            size="small"
                          >
                            {item.Name.split(" ")
                              .map(n => n[0])
                              .filter((_, idx) => idx < 2)
                              .join("")}
                          </Avatar>

                          <span className="text-black">{item.Name}</span>
                        </Space>

                        <RxCross2
                          onClick={() => handleRemovePerson(item.ObjectId)}
                          className="font-base cursor-pointer"
                        />
                      </Flex>
                    </Col>
                  </Row>
                </>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
}

export default PersonRecipientsList;